import React from "react";
import { HorizontalBar } from "react-chartjs-2";

const WorkOrderByStatus = ({workOrderByStatus}) => {
  console.log("data-open", workOrderByStatus)
  const data = {
    labels: workOrderByStatus &&  workOrderByStatus.statuses.map((item) => item.status) || [],
    datasets: [
      {
        data: workOrderByStatus &&  workOrderByStatus.statuses.map((item) => item.count) || [],
        backgroundColor: ["#FF5722", "#16A085", "#40a9ff", "#28192087"],
        borderColor: ["#FF5722", "#16A085", "#40a9ff", "#28192087"],
        borderWidth: 1,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,

    legend: {
      display: false,
    },

    tooltips: {
      enabled: true,
    },

    scales: {
      xAxes: [
        {
          ticks: {
            beginAtZero: true,
          },
          gridLines: {
            color: "#e0e0e0",
          },
          scaleLabel: {
            display: true,
          },
        },
      ],

      yAxes: [
        {
          barPercentage: 0.5,
          scaleLabel: {
            display: true,
          },
          gridLines: {
            display: false,
          },
        },
      ],
    },
  };

  return (
    <div
      style={{
        height: "350px",
      }}
      className="order-status-class"
    >
      
      <div className="zone-wise-header">
         <div className="header wrapper-header">
         <div className="icon-wrapper">
             <i className="material-icons">description</i>
            </div>
        <div>
          <h2>Work Order By Status</h2>
        </div>
      </div>
        <div className="receipt-header">
        <span>Financial Year : {workOrderByStatus.financialYear}</span>
        <span>|</span>
        <span>ULB : {workOrderByStatus.ulbName}</span>
      </div>
      </div>

      <HorizontalBar data={data} options={options} />
    </div>
  );
};

export default WorkOrderByStatus;



// WEBPACK FOOTER //
// src/modules/employee/Home/WorkOrderByStatus.js